import * as React from 'react';
import type { DataGridHeaderMenuProps } from './header';

/**
 * Data Grid Header Menu
 * 
 * NOTE: This is not currently used in the Data Grid component; however this is left here in the event we
 * decide to bring back the header menu functionality.
 *
 * @param options - The Header Menu options
 * @param options.columnKey
 * @param options.hideColumn - If defined, adds an option to hide the column
 * @param options.sortAsc - If defined, adds an option to sort the table data using this column, ascending
 * @param options.sortDesc - If defined, adds an option to sort the table data using this column, descending
 * @returns
 */
export const DataGridHeaderMenu: React.FC<DataGridHeaderMenuProps> = ({
	columnKey,
	hideColumn,
	sortAsc,
	sortDesc
}) => {
	const [isOpen, setIsOpen] = React.useState(false);

	const handleHideColumn = () => {
		hideColumn && hideColumn(columnKey);
		setIsOpen(false);
	};

	const handleMouseEnter = () => {
		setIsOpen(true);
	};

	const handleMouseLeave = () => {
		setIsOpen(false);
	};

	const handleSortAsc = () => {
		sortAsc && sortAsc(columnKey);
		setIsOpen(false);
	};

	const handleSortDesc = () => {
		sortDesc && sortDesc(columnKey);
		setIsOpen(false);
	};

	return (
		<div data-aid="data-grid-header-menu" className="relative inline-block text-left" onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
			<button className="flex h-8 w-8 items-center justify-center text-gray-500 hover:text-gray-700">⋮</button>
			{isOpen && (
				<div className="z-100 absolute right-0 w-48 rounded-md border border-gray-200 bg-white shadow-lg">
					{sortAsc && <MenuButton onClick={handleSortAsc}>Sort Asc</MenuButton>}
					{sortDesc && <MenuButton onClick={handleSortDesc}>Sort Desc</MenuButton>}
					{hideColumn && <MenuButton onClick={handleHideColumn}>Hide Column</MenuButton>}
				</div>
			)}
		</div>
	);
};

interface MenuButtonProps {
	children: React.ReactNode;
	onClick: () => void;
}

function MenuButton({ onClick, children }: MenuButtonProps) {
	return (
		<button onClick={onClick} className="block w-full px-4 py-2 text-left text-sm text-gray-700 hover:bg-gray-100">
			{children}
		</button>
	);
}
